import { Toaster } from "sonner";
import { AppRoutes } from "./routes";
import { AuthProvider } from "@/contexts/AuthContext";
import { InstallPwaPrompt } from "@/components/pwa/InstallPrompt";
import { CapacitorBackButton } from "@/components/native/CapacitorBackButton";
import { QueryProvider } from "@/providers/QueryProvider";
import { ThemeSync } from "@/providers/ThemeSync";

export function App() {
  return (
    <QueryProvider>
      <AuthProvider>
        <ThemeSync />
        <Toaster richColors position="top-right" closeButton />
        <InstallPwaPrompt />
        <CapacitorBackButton />
        <AppRoutes />
      </AuthProvider>
    </QueryProvider>
  );
}
